import { Forgotlink, FormSubmitBtn, InputFieldStyle } from '../FormsStyled';
import { Dialog, DialogContent, DialogTrigger, FormErrorColor, ModelTopMargin, SafeGuardStyle, FormForgotText } from '../ModalStyled';
import { FormHeading } from '../Styled';
import React, { useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useHistory } from "react-router-dom"
import axios from 'libs/axios';
import { toast } from 'react-toastify';
import { ReactComponent as KeyIcon } from 'assets/Icons/KeyIcon.svg';

type Inputs = {
    email: string,
};

const ForgotpasswordModal: React.FC = () => {

    const { register, handleSubmit, getValues, formState: { errors } } = useForm<Inputs>();
    const history = useHistory();
    const [loading, setLoading] = useState(true);

    const onSubmit: SubmitHandler<Inputs> = async data => {
        try {
            setLoading(true);
            const result = await axios.post('/user/forget', data);
            toast.success(result.data.message);
            history.push("/forgotpassword");
        } catch (err) {
            //@ts-ignore
            toast.error(err.response.data.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        //because this form is rendered within login form, so to avoid login form submission.
        <Dialog>

            <DialogTrigger asChild>

                <Forgotlink>
                    <button type='button'>Forgot Password?</button>
                </Forgotlink>
            </DialogTrigger>

            <DialogContent>

                <SafeGuardStyle>
                    <KeyIcon />
                </SafeGuardStyle>

                <ModelTopMargin onSubmit={e => e.stopPropagation()} >
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <FormHeading>
                            <FormForgotText>Forgot Password</FormForgotText>
                        </FormHeading>

                        <InputFieldStyle>
                            <label>Email</label>
                            <input type="email" className="form-control ForgotModelInputWidth" {...register("email", { required: { value: true, message: "Email is Required" }, pattern: { value: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: "Invalid Email" } })} />
                            <FormErrorColor>{errors.email && errors.email.message}</FormErrorColor>
                        </InputFieldStyle>

                        <FormSubmitBtn>
                            <button type="submit">Submit</button>
                        </FormSubmitBtn>
                    </form>
                </ModelTopMargin>

            </DialogContent>
        </Dialog >

    )
}

export default ForgotpasswordModal;